<template>
  <div class="error-hint-pane flex column">
    <div>
      <img src="@/assets/img/loading_failed.png" alt="">
    </div>
    <div class="text">
      <span>加载失败，请重试</span>
    </div>
    <div>
      <button class="normal" @click="onReload">重新加载</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ErrorHint',
  methods: {
    onReload(e){
      this.$emit('click', e)
    }
  }
}
</script>
<style scoped>
.error-hint-pane{
  text-align: center;
  padding-bottom: .5rem;
}
.error-hint-pane img{
  width: 2.7rem;
}
.error-hint-pane .text{
  color: #505050;
  margin-bottom: .16rem;
}
.error-hint-pane button{
  box-shadow: 0 .04rem .1rem 0 rgba(20, 98, 244, 0.3);
}
</style>